// Hirá: product page bundle picker + automatic refills checkbox.
//
// - The chosen bundle (1 / 2 / 4) becomes the cart quantity.
// - The Add to cart pill shows the bundle total (after the bundle and refill discounts) and the
//   crossed-out regular total. hira-pdp.js renders it from the per-unit values set here.
// - Live mode: ticking refills writes `selling_plan` into the add-to-cart form, so the item is
//   added as a subscription. Demo mode (no selling plans yet): visual only, nothing extra is sent.
(() => {
  const SELECTOR = '[data-hira-purchase]';

  const scopeOf = (root) => root.closest('.product-details') || document;

  const setSellingPlan = (root, planId) => {
    const form = scopeOf(root).querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    let input = form.querySelector('input[name="selling_plan"]');
    if (!planId) {
      input?.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      form.append(input);
    }
    input.value = planId;
  };

  const apply = (root) => {
    const scope = scopeOf(root);
    const bundle = root.querySelector('.hira-bundles input:checked');
    const quantity = Math.max(1, parseInt(bundle?.value, 10) || 1);
    const bundleDiscount = Number(bundle?.dataset.discount) || 0;
    const subscribe = root.querySelector('[data-hira-subscribe]');
    const subscribing = Boolean(subscribe?.checked);
    const subDiscount = subscribing ? Number(root.dataset.subDiscount) || 0 : 0;
    const live = root.dataset.mode === 'live';

    root.querySelectorAll('.hira-bundle').forEach((label) => {
      label.classList.toggle('is-selected', label.contains(bundle));
    });
    root.querySelector('.hira-refill')?.classList.toggle('is-selected', subscribing);
    const frequency = root.querySelector('[data-hira-frequency]');
    if (frequency) frequency.hidden = !subscribing;

    // Per-unit values; hira-pdp.js multiplies them by the quantity.
    // Whole-dollar price per bottle (matching the bundle cards); the refill total is rounded too.
    const unitPrice = Number(root.dataset.unitPrice) || 0;
    const unitCompare = Number(root.dataset.unitCompare) || unitPrice;
    const perBottle = Math.round((unitPrice * (100 - bundleDiscount)) / 10000) * 100;
    const bundleTotal = perBottle * quantity;
    const total = subDiscount ? Math.round((bundleTotal * (100 - subDiscount)) / 10000) * 100 : bundleTotal;

    const price = scope.querySelector('.hira-atc-price');
    const compare = scope.querySelector('.hira-atc-compare');
    if (price) price.dataset.unitCents = String(total / quantity);
    if (compare) compare.dataset.unitCents = String(unitCompare);

    const quantityInput = scope.querySelector('input[name="quantity"]');
    if (quantityInput) {
      quantityInput.value = String(quantity);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const plan = root.querySelector('[data-hira-plan]');
    setSellingPlan(root, live && subscribing ? plan?.value : '');
  };

  document.addEventListener('change', (event) => {
    const root = event.target instanceof Element ? event.target.closest(SELECTOR) : null;
    if (root) apply(root);
  });

  const init = () => document.querySelectorAll(SELECTOR).forEach(apply);

  // Variant changes re-render the buy buttons; re-apply the current choices
  document.addEventListener('variant:update', () => requestAnimationFrame(init));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
